var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simulator-portfolio-table" },
    [
      _c("v-data-table", {
        staticClass: "table-new-ux-group-by-v1",
        attrs: {
          headers: _vm.visibleHeaders,
          items: _vm.tableRows,
          "group-by": _vm.groupBy,
          "custom-sort": _vm.customSort,
          "hide-default-footer": "",
          "disable-pagination": ""
        },
        scopedSlots: _vm._u([
          {
            key: "group.header",
            fn: function(ref) {
              var group = ref.group
              var groupItems = ref.items
              return _vm._l(_vm.visibleHeaders, function(headerItem) {
                return _c(
                  "td",
                  {
                    key: headerItem.value || headerItem.text,
                    staticClass: "text-semibold"
                  },
                  [
                    headerItem.value === "nome_ativo"
                      ? _c("span", [_vm._v(" " + _vm._s(group) + " ")])
                      : headerItem.value === "aplicacao" ||
                        headerItem.value === "Aplicação"
                      ? _c("span", [
                          _vm._v(" " + _vm._s(_vm.sumPl(groupItems)) + " ")
                        ])
                      : headerItem.value === "percent"
                      ? _c("span", [
                          _vm._v(" " + _vm._s(_vm.sumPercent(groupItems)) + " ")
                        ])
                      : _vm._e()
                  ]
                )
              })
            }
          },
          {
            key: "item.nome_ativo",
            fn: function(ref) {
              var item = ref.item
              return [
                !_vm.isCompact
                  ? _c("div", [
                      _vm._v(" " + _vm._s(item.nome_ativo || "—") + " ")
                    ])
                  : _c("v-hover", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var hover = ref.hover
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "simulator-portfolio-table__asset"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "div",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "text-truncate simulator-portfolio-table__asset-name-compact"
                                                            },
                                                            "div",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.nome_ativo ||
                                                                  "—"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(item.nome_ativo || "—")
                                              )
                                            ])
                                          ]
                                        ),
                                        _c("CommentDisplay", {
                                          staticClass: "ml-1",
                                          attrs: {
                                            "display-mode": "icon",
                                            "comment-text":
                                              item && item.comentario,
                                            "has-extra-content":
                                              _vm.getTags(item).length > 0,
                                            "is-hovering": hover,
                                            "empty-tooltip-label":
                                              "Editar comentário e tags"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.emitEditNotes(item)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.getTags(item).length
                                      ? _c("ClientTags", {
                                          staticClass:
                                            "simulator-portfolio-table__asset-tags",
                                          attrs: {
                                            tags: _vm.getTags(item),
                                            useSmallChips: ""
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
              ]
            }
          },
          {
            key: "item.referencia",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", [
                  _vm._v(" " + _vm._s(_vm.formatReference(item)) + " ")
                ])
              ]
            }
          },
          {
            key: "item.aplicacao",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", { staticStyle: { "white-space": "nowrap" } }, [
                  _vm._v(" " + _vm._s(item.aplicacao) + " ")
                ])
              ]
            }
          },
          {
            key: "item.recomendacao",
            fn: function(ref) {
              var item = ref.item
              return [
                item.recomendacao
                  ? _c(
                      "v-chip",
                      {
                        attrs: {
                          "x-small": "",
                          color:
                            _vm.recomendacaoColors[item.recomendacao] || "grey",
                          dark: ""
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.recomendacaoLabels[item.recomendacao] ||
                                item.recomendacao
                            ) +
                            " "
                        )
                      ]
                    )
                  : _c("span", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.setor",
            fn: function(ref) {
              var item = ref.item
              return [
                item.setor
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "text-truncate",
                                          staticStyle: { "max-width": "120px" }
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(" " + _vm._s(item.setor) + " ")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [_c("span", [_vm._v(_vm._s(item.setor))])]
                    )
                  : _c("div", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.comentario",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("CommentDisplay", {
                  attrs: {
                    "comment-text": item && item.comentario,
                    "display-mode": "text"
                  }
                })
              ]
            }
          },
          {
            key: "item.tags",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm.getTags(item).length
                  ? _c("ClientTags", {
                      attrs: {
                        tags: _vm.getTags(item),
                        "max-tags-display": _vm.maxTagsDisplay,
                        useSmallChips: ""
                      }
                    })
                  : _c("div", [_vm._v(" - ")])
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("TableRowActions", { attrs: { actions: item.actions } })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }